import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-pure-black border-t border-white/10">
      <div className="container-max py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2">
           <Link to="/" className="flex items-center gap-2.5" aria-label="CodeViora home">
            <img src={require('../images/Codeviora.webp')} alt="CodeViora Logo" className="h-8 w-auto object-contain" />
          </Link>
            <p className="text-white/40 text-sm leading-relaxed max-w-xs">
              End-to-end IT services — web development, design, apps, SEO, and digital marketing for businesses that want to grow.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="https://www.linkedin.com/company/codeviora/" target="_blank" rel="noopener noreferrer" aria-label="CodeViora on LinkedIn" className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white hover:text-black flex items-center justify-center text-white/40 text-xs font-bold transition-all"><i className="fab fa-linkedin-in text-sm"></i></a>
            </div>
          </div>
          {[
            { title: 'Services', links: [['Web Development','/services'],['Web Design','/services'],['App Development','/services'],['SEO','/services'],['Digital Marketing','/services']] },
            { title: 'Company',  links: [['About Us','/about'],['Blog','/blog'],['Contact','/contact'],['Careers','/contact']] },
            {
              title: 'Contact',
              links: [
                ['chaturbhujarani78@gmail.com', 'mailto:chaturbhujarani78@gmail.com'],
                ['+91 8699393272', 'tel:+918699393272'],
                ['India (Remote)', '/contact']
              ]
            },
          ].map(({ title, links }) => (
            <div key={title}>
              <h3 className="text-xs font-bold tracking-widest uppercase text-white/30 mb-5">{title}</h3>
              <ul className="flex flex-col gap-3">
                {links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-sm text-white/40 hover:text-white transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-max py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-xs">© {new Date().getFullYear()} CodeViora. All rights reserved.</p>
          <p className="text-white/25 text-xs">Made in India 🇮🇳</p>
        </div>
      </div>
    </footer>
  );
}
